import { ProjectType } from "../models/project-type.model";
import { ProjectTypeStateModel } from "../state/project-type.state";

export namespace ProjectTypeActions {
    export class Refresh {
        static readonly type = '[API-ProjectType] Refresh'
        constructor() {}
    }
    export class Init {
        static readonly type = '[Storage-ProjectType] Init'
        constructor(public payload: ProjectTypeStateModel) {}
    }
    export class Set {
        static readonly type = '[API-ProjectType] Set'
        constructor(public payload: ProjectType[]) {}
    }
}
